export default __webpack_public_path__ + "static/media/pink.9badab58.png";